import {Component, Input, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConstantsService} from '../../../../_services/constants.service';

@Component({
  selector: 'app-analyticsfacebooksummary',
  templateUrl: './analyticsfacebooksummary.component.html',
  styleUrls: ['./analyticsfacebooksummary.component.css']
})
export class AnalyticsfacebooksummaryComponent implements OnInit {
  @Input('details') details: any;
  @Input('analytics') analytics: any;

  constructor(
    private http: HttpClient,
    private constant: ConstantsService
  ) {
  }

  ngOnInit() {
  }

  getFacebookAnalytics() {
    return this.http.post<any>(`${this.constant.read('')}`, {}).subscribe(res => {
      //console.log(res)
    }, err => {
      //console.log(err);
    })
  }
}
